import { Button, Input } from 'antd';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { trackButtonClick } from '../../analytics/mixpanel';
import { SendRight } from '../../assets';
import CollapseIconSVG from '../../assets/CollapseIconSVG';
import ExpandIconSVG from '../../assets/ExpandIconSVG';
import { useTextAreaNumberOfLines } from '../../CommonFuctions/useTextAreaNumberOfLines';
import InlineStyled from '../InlineStyled/InlineStyled';

const StyledTextArea = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  outline: 1px solid rgba(0, 0, 0, 0.1);
  padding: 4px;

  .chatbot-input,
  .chatbot-input:focus,
  .chatbot-input:focus-within {
    border-radius: 16px;
    margin-bottom: 0;
    border: none;
    outline: none;
    box-shadow: none;
    resize: none;
  }
  textarea {
    padding-right: 27px;
    transition: none;
  }
`;

const ResizableTextArea = ({ value, onChange, disabled, handleSend, id = '' }) => {
  const chatInputRef = useRef(null);
  const [textAreaExpanded, setTextAreaExpanded] = useState(false);

  const numberOfLines = useTextAreaNumberOfLines(
    chatInputRef.current?.resizableTextArea?.textArea,
    [value, textAreaExpanded]
  );

  function getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;

    ctx.font = font;
    return ctx.measureText(text).width;
  }

  const [isFirstLineFilled, setIsFirstLineFilled] = useState(false);

  useEffect(() => {
    if (!chatInputRef.current) return undefined;
    const { textArea } = chatInputRef.current.resizableTextArea;

    const frame = requestAnimationFrame(() => {
      const style = window.getComputedStyle(textArea);
      const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
      const textWidth = getTextWidth(textArea.value, font);
      const inputWidth = textArea.clientWidth;

      setIsFirstLineFilled(textWidth >= inputWidth - 70);
    });

    return () => cancelAnimationFrame(frame);
  }, [value]);

  return (
    <StyledTextArea id={id}>
      {numberOfLines > 5 && (
        <InlineStyled
          as={Button}
          $style={{ position: 'absolute', right: 4, zIndex: 10 }}
          color='default'
          type='text'
          onClick={() => {
            trackButtonClick({ type: `${textAreaExpanded ? 'Collapse' : 'Expand'} Text Area` });
            setTextAreaExpanded((prev) => !prev);
          }}
          icon={textAreaExpanded ? <CollapseIconSVG /> : <ExpandIconSVG />}
        />
      )}
      <Input.TextArea
        ref={chatInputRef}
        placeholder='Press Enter to Send & Shift + Enter for Next Line'
        value={value}
        autoSize={{ minRows: textAreaExpanded ? 22 : 1, maxRows: 10 }}
        onChange={onChange}
        disabled={disabled}
        className='chatbot-input'
        onPressEnter={(e) => {
          if (!e.shiftKey) {
            e.preventDefault();
            handleSend(value);
          }
        }}
        tabIndex={-1}
      />
      <InlineStyled
        as={Button}
        $style={
          isFirstLineFilled || numberOfLines > 1
            ? { alignSelf: 'flex-end' }
            : { position: 'absolute', right: 4 }
        }
        onClick={() => handleSend(value)}
        icon={<SendRight />}
        disabled={!value || disabled}
      />
    </StyledTextArea>
  );
};

export default ResizableTextArea;
